import { render, staticRenderFns } from "./Adminpage.vue?vue&type=template&id=d5ceeefa&scoped=true&"
import script from "./Adminpage.vue?vue&type=script&lang=js&"
export * from "./Adminpage.vue?vue&type=script&lang=js&"
import style0 from "./Adminpage.vue?vue&type=style&index=0&id=d5ceeefa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ceeefa",
  null
  
)

export default component.exports